import { quickstock } from "./quick-stock";

export const es = {
  quickstock
};
